"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeEvent = exports.Events = void 0;
var Events;
(function (Events) {
    Events["BUTTON_REQUEST"] = "BUTTON_REQUEST";
    Events["CANCEL"] = "CANCEL";
    Events["CHARACTER_REQUEST"] = "CHARACTER_REQUEST";
    Events["CONNECT"] = "CONNECT";
    Events["DISCONNECT"] = "DISCONNECT";
    Events["FAILURE"] = "FAILURE";
    Events["PASSPHRASE_REQUEST"] = "PASSPHRASE_REQUEST";
    Events["PIN_REQUEST"] = "PIN_REQUEST";
    Events["SUCCESS"] = "SUCCESS";
    Events["WORD_REQUEST"] = "WORD_REQUEST";
})(Events = exports.Events || (exports.Events = {}));
function makeEvent(e) {
    return Object.assign({ date: Date.now() }, e);
}
exports.makeEvent = makeEvent;
